export const mockUser = {
  id: "621d06554a009c0013407de1",
  firstName: "Devin",
  lastName: "Carter",
  full_name: "Devin Carter",
  email: "test@test.com",
};
